import * as React from "react"
import {WithModalStore} from "../App"

export function ModalRoot(props: WithModalStore) {
  const {modal} = props.modalStore.state

  if (!modal) {
    return null
  }

  return modal.visit((Type, props) => <Type {...props} />)
}



// WEBPACK FOOTER //
// ./src/components/ModalRoot.tsx